import { combineReducers } from "redux";
import searchContextReducer from "./SearchContextReducer"; 
import productHistory from "./manageProductHistoryReducer"; 
import productHistRow from "./ProductHistoryRowDataReducer";
import productHistPga from "./productHistPgaReducer";
import dynamicPgaData from "./dynamicPgaReducer";
import docBarReducer from "./DocBarReducer";
import manageDropdownReducer from './ManageDropdownReducer'
import PGAReducerWithMerchandiseId from "../CBP_App/reducer/PGAReducer";
import { ediReducers } from "../vendor/kn-edi-ui/store/reducers";

export default combineReducers({
  searchContext: searchContextReducer,
  productHistory,
  productHistRow,
  productHistPga,
  dynamicPgaData,
  PGAReducerWithMerchandiseId,
  docBarReducer,
  manageDropdownReducer,
  ...ediReducers
});
